let hotels = [
    {
        pid:0,
        img:"https://i.ibb.co/cDhW86k/Rectangle-27.png",
        name:"Light bright airy stylish apt  safe peaceful stay",
        detailsOne:"4 guests   2 bedrooms   2 beds   2 baths",
        detailsTwo:"Wif Air conditioning Kitchen",
        detailsThree:"Cancellation fexibility availiable",
        detailsFour:"$34/night",
       
     },
     {
        pid:0,
        img:"https://i.ibb.co/mC1r8wn/Rectangle-26.png",
        name:"Apartment in Lost Panorama",
        detailsOne:"4 guests   2 bedrooms   2 beds   2 baths",
        detailsTwo:"Wif Air conditioning Kitchen",
        detailsThree:"Cancellation fexibility availiable",
        detailsFour:"$52/night",
       
     },
     {
        pid:0,
        img:"https://i.ibb.co/V2jTJPm/Rectangle-28.png",
        name:"AR Lounge & Pool (r&r + b&b)",
        detailsOne:"4 guests   2 bedrooms   2 beds   2 baths",
        detailsTwo:"Wif Air conditioning Kitchen",
        detailsThree:"Cancellation fexibility availiable",
        detailsFour:"$44/night",
       
     },
     {
        pid:1,
        img:"https://images.unsplash.com/photo-1558976825-6b1b03a03719?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
        name:"Light bright airy stylish apt  safe peaceful stay",
        detailsOne:"4 guests   2 bedrooms   2 beds   2 baths",
        detailsTwo:"Wif Air conditioning Kitchen",
        detailsThree:"Cancellation fexibility availiable",
        detailsFour:"$34/night",
       
     },
     {
        pid:1,
        img:"https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
        name:"Apartment in Lost Panorama",
        detailsOne:"4 guests   2 bedrooms   2 beds   2 baths",
        detailsTwo:"Wif Air conditioning Kitchen",
        detailsThree:"Cancellation fexibility availiable",
        detailsFour:"$52/night",
       
     },
     {
        pid:1,
        img:"https://images.unsplash.com/photo-1588840103995-02893d4eb8fd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
        name:"AR Lounge & Pool (r&r + b&b)",
        detailsOne:"4 guests   2 bedrooms   2 beds   2 baths",
        detailsTwo:"Wif Air conditioning Kitchen",
        detailsThree:"Cancellation fexibility availiable",
        detailsFour:"$44/night",
       
     },
     {
        pid:2,
        img:"https://images.unsplash.com/photo-1561391922-3c04a61b77d4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
        name:"Light bright airy stylish apt  safe peaceful stay",
        detailsOne:"4 guests   2 bedrooms   2 beds   2 baths",
        detailsTwo:"Wif Air conditioning Kitchen",
        detailsThree:"Cancellation fexibility availiable",
        detailsFour:"$34/night",
       
     },
     {
        pid:2,
        img:"https://images.unsplash.com/photo-1524524692660-9838adb9c179?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
        name:"Apartment in Lost Panorama",
        detailsOne:"4 guests   2 bedrooms   2 beds   2 baths",
        detailsTwo:"Wif Air conditioning Kitchen",
        detailsThree:"Cancellation fexibility availiable",
        detailsFour:"$52/night",
       
     },
     {
        pid:2,
        img:"https://images.unsplash.com/photo-1547473078-cbab237054c0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
        name:"AR Lounge & Pool (r&r + b&b)",
        detailsOne:"4 guests   2 bedrooms   2 beds   2 baths",
        detailsTwo:"Wif Air conditioning Kitchen",
        detailsThree:"Cancellation fexibility availiable",
        detailsFour:"$44/night",
       
     },
   
   
 ];
 
 export default hotels;